import React from "react";
import "../../assets/css/app.css";
import { NavLink } from "react-router-dom";
import "./AboutUsMore.css";
import abtGirl from "../../assets/imgs/abtGirl.jpg";
import abtgrl2 from "../../assets/imgs/abtgrl2.jpg";
import ab1 from "../../assets/imgs/ab1.jpg";
import ab2 from "../../assets/imgs/ab2.jpg";
import ab3 from "../../assets/imgs/ab3.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade"; 
import { useEffect } from "react";
import { motion } from "framer-motion";

function AboutUsMore() {
  

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); 
  
    return (
      <motion.div
      initial={{ opacity: 0, y: 50 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5, ease: "easeOut" }}
      
      
    >
       <div className="bcrumb">
       <div className="maxW">
       <div className="breadcrumb">
        <NavLink to="/">Home  </NavLink>/ <span>About Us</span>
       </div>
       </div>
       </div>
        <div className="abtUs">
          <div className="maxW">
            <h2>ABOUT US</h2>
            <div className="abtMain">
              <div className="abtLft">
                <p>
                  Established in 1991, a government-recognized company.
                  A very fast-growing company with its motto and aim to work with
                  customers with total honesty and dedication.
                </p>
                <p><strong>Area: </strong>Over 25,000 sq. ft. of state-of-the-art working space</p>
                <p><strong>Work Power: </strong>A dedicated team of 100+ skilled employees</p>
                <p><strong>Production Capacity: </strong>Capable of producing 100,000+ pieces
                per month*</p>

              </div>
              <div className="abtRyt">
                <Swiper
                  modules={[Autoplay, EffectFade]} 
                  effect="fade"
                  autoplay={{ delay: 2000 }} 
                  className="mySwiper"
                  loop={true}
                >
                  <SwiperSlide>
                    <img src={abtGirl} alt="abtGirl-img" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={abtgrl2} alt="abtGirl-img" />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
            <div className="abBtm">
              <h5>OUR FABRICS</h5>
              <p className="abPara">All types of cotton, viscose, polyester, wool, silk, linen, canvas and jute. We have very good command in printing, dyeing & tie/dye.We are specializing in very soft
chiffon quality with latest print.Worked with all major importers and department stores in Europe and in Canada.We have advantage of developing of any project
and samples in very quick time, we have very satisfied customers working with us for more than 15-20 years.</p>
<p className="abPara">All the samples are made by the designers with personal screening.of the directors and then handed over to the showroom staff for photo session and all the presentation.All the sample requirements and production details are handled by our merchandisers which are separate for both the departments.They ensure timely sample delivery and same for the production.</p>
            </div>
          </div>
          <div className="slWrp">
          <div className="maxW">
            <div className="abslde">
            <div className="absMn">
              <img src={ab3} alt="ab3-img" />
              <h5>ALL FABRICS</h5>
              </div>
              <div className="absMn">
              <img src={ab2} alt="ab2-img" />
              <h5>DESIGNING</h5>
              </div>
              <div className="absMn">
              <img src={ab1} alt="ab1-img" />
              <h5>CUSTOMER SATISFACTION</h5>
              </div>
            </div>
            </div>
          </div>
        </div> 
        </motion.div>
      );
}

export default AboutUsMore